export const state = {
  data: {},
  common: {
    domain: document.domain,
    user: {
      token: null,
      env: null,
      countryCode: null,
      os: null,
    },
    params: {},
    query: {},
  },
}

export const getters = {
  userEnv(state, getters) {
    const { common } = state
    // validate if there is a 'dev=true' query param
    return common.query.dev === 'true' ? 'DEV' : getters.baseEnv
  },
  baseEnv(state) {
    const { common } = state
    return common.domain.includes('dev') ? 'DEV' : common.user.countryCode
  },
  logsUserID(state) {
    const { data, common } = state
    return data && data.SharedData && data.SharedData.userData
      ? `${common.user.countryCode}_${data.SharedData.userData.id}`
      : null
  },
  zendeskArticleParams(state, getters) {
    const { common } = state
    return Object.assign(
      {},
      common.query,
      common.params,
      {
        screen_id: getters.zendeskScreenId,
      },
      {
        order_id: Number(common.query.order_id), // eslint-disable-line
      }
    )
  },
  articleBuilderBody(state) {
    const { common } = state
    return Object.assign(
      {},
      {
        order_id:
          Number(common.query.order_id) > 1000 // eslint-disable-line
            ? Number(common.query.order_id) // eslint-disable-line
            : null,
        article_id: common.params.articleId,
      }
    )
  },
  screenBuilderBody(state) {
    const { common } = state
    return Object.assign(
      {},
      {
        order_id:
          Number(common.query.order_id) > 1000 // eslint-disable-line
            ? Number(common.query.order_id) // eslint-disable-line
            : null,
        screen_id: common.params.screenId,
      }
    )
  },
  zendeskScreenId(state) {
    return `SAM_ZENDESK_ARTICLE_${state.common.params.articleId}`
  },
  widgets(state) {
    return state.data
  },
  widget(state) {
    return widgetName => state.data[widgetName]
  },
  widgetProperty(state) {
    return (widgetName, property) => state.data[widgetName][property]
  },
  notSatisfiedUser(state) {
    const satisfied = state.data['ScreenSatisfaction']
      ? state.data['ScreenSatisfaction']['notSatisfied'] === false
      : true
    return satisfied
  },
  rtIssuedPaymentState(state) {
    const widget = state.data['PaymentsRt']
    const payment = widget ? widget['issuedPayment'] : null
    return payment
  },
  isFormWidgetRendered(state) {
    return !!state.data['Form']
  },
  userType(state) {
    const sharedDataInstance = state.data['SharedData']

    return sharedDataInstance && sharedDataInstance.userData
      ? sharedDataInstance.userData.ownerType
      : 'null'
  },
}

export const mutations = {
  SET_WIDGET_DATA(state, { label, data }) {
    state.data = Object.assign({}, state.data, {
      [label]: data,
    })
  },
  SET_USER_DATA(state, user) {
    state.common.user = Object.assign({}, state.common.user, user)
  },
  SET_PARAMS(state, params) {
    state.common.params = Object.assign({}, state.common.params, params)
  },
  SET_QUERY(state, query) {
    // query.order_id = parseInt(query.order_id)
    state.common.query = Object.assign({}, state.common.query, query)
  },
  SET_WIDGET_CHANGE(state, { widgetName, data }) {
    const widgetMutation = Object.assign({}, state.data[widgetName], data)
    state.data = Object.assign({}, state.data, {
      [widgetName]: widgetMutation,
    })
  },
}

export const actions = {
  commitWidgetData({ state, dispatch, commit }, componentData) {
    commit('SET_WIDGET_DATA', componentData)
  },
  commitUser({ state, dispatch, commit, getters }, userData) {
    const { countryCode } = userData
    const u = Object.assign({}, userData, {
      countryCode: countryCode ? countryCode.toUpperCase() : '',
      env: getters.userEnv,
    })
    commit('SET_USER_DATA', u)
  },
  commitParams({ state, dispatch, commit }, params) {
    commit('SET_PARAMS', params)
  },
  commitQuery({ state, dispatch, commit }, query) {
    commit('SET_QUERY', query)
  },
  commitWidgetChanges({ state, dispatch, commit }, data) {
    commit('SET_WIDGET_CHANGE', data)
  },
}
